import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state:{
    //存放组件之间共享的数据
    timer:'',  //全局的定时器
  },
  mutations: {
    //显式的更改state里的数据
    setTimer(state,timer){
      state.timer = timer
    },
  },
  getters:{
    //获取数据的方法
  },
  actions:{
    //设置延时
  }
});

export default store



// WEBPACK FOOTER //
// ./src/store/index.js